<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                :callbacks="{ refreshData: refreshEosrcCard, saveData: saveEosrcCard, isDirty: null }"
                :meta="eosrcCardMeta"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
                :use-default-buttons="true"
                components-path="views/e-grid/eosrc-card/field-wrappers"
            />
        </div>
    </div>
</template>
<script setup>
import cardForm from '@/components/card-component/card-form.vue';
import eosrcCardMeta from '@/views/e-grid/eosrc-card/card-meta';
import { insEosrcCard } from '@/service/e-grid-service';
import { useRouter } from 'vue-router';

const router = useRouter();

const refreshEosrcCard = async () => {
    return {
        result: true,
        data: {
            eobj_id: null,
            kod_srckind: null,
            kindname: null,
            dnum: null,
            sname: null,
            fname: null,
            kodp_seti: [],
            setiname: [],
            bal_id: null,
            bkod_separator: null,
            bkod_ecls: null,
            bname: null,
            expl_id: null,
            ekod_parent: null,
            ekod_separator: null,
            ename: null,
            schema_invalid: null,
            is_uc: false,
            vltgs: null,
            addr_id: null,
            addrkind: null,
            adr: null,
            latitude: null,
            longitude: null,
            yearofplugin: null,
            yearofpluginafterreconstr: null,
            coment: null,
            tech_location_code: null,
            imported: null,
            deleted: null,
            kod_v: null,
            kod_v_low: null,
            kod_v_mdl: null,
        },
    };
};
const saveEosrcCard = async data => {
    const response = await insEosrcCard(data);
    console.log('saveEosrcCard', response);
    if (response.result && response.success) {
        await router.push({
            name: 'EosrcCard',
            params: { id: response.data.eobj_id },
        });
    }
    return response;
};
</script>
